import React, { useEffect } from 'react';
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider';
import styled from 'styled-components';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import PageFooter from '../Theme/PageFooter';
import VoucherCode from './VoucherCode';
import VoucherInfo from './VoucherInfo';
import StoreVoucher from './StoreVoucher';
import InformationSection from './InformationSection';
import Transactions from './Transactions';
import Loader from '../Theme/Loader';
import { getReceiverOpen } from '../../services/api/api';
import { DEFAULT_TITLE } from '../../constants';
import { useUserContext } from '../../lib/contextProviders/contexts/userContext';
import EcommBanner from './EcommBanner';

const MainContainer = styled.div`
  background: #fff;
`;
const CardContainer = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    display: flex;
    justify-content: center;
    max-width: 100%;
    margin: 1rem auto 0;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    > :first-child {
      width: 24.5rem;
    }
  }

  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: '6rem';
  }

  ${SCREEN_SIZE.Only.MobileL} {
    margin-bottom: '6rem';
  }
`;

const WrpDiv = styled.div`
  padding-bottom: 1rem;
  ${SCREEN_SIZE.From.Tablet} {
    flex: 1;
  }

  ${SCREEN_SIZE.From.Desktop} {
    flex: 0;
    flex-basis: 100%;
    max-width: 980px;
  }
`;

const ShowFooterSection = styled.div`
  border-top: 1px solid #eaeaea;
  ${SCREEN_SIZE.From.Tablet} {
    display: block;
    border-top: 1px solid #eaeaea;
  }
`;

const ReceiverPageContent = styled.div`
  max-width: 705px;
  margin: 0 auto;
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  li {
    margin: 0;
  }
`;

const SeprateHeadLine = styled.div`
  height: 1px;
  background: #eaeaea;
  position: relative;
  top: 10px;
  margin-bottom: 60px;
`;

const FAQSection = styled.div`
  margin-top: 2rem;
  h2 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 23px;
    line-height: 32px;
    text-align: center;
    color: #333333;
  }
`;
const AcrodianSection = styled.div`
  margin-top: 2rem;
  h6 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #1454b8;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    padding-left: 15px;
    padding-right: 15px;
  }
  ${SCREEN_SIZE.From.MobileL} {
    padding-left: 15px;
    padding-right: 15px;
  }
  ${SCREEN_SIZE.From.Tablet} {
    padding-left: 0px;
    padding-right: 0px;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const Receiver = (props) => {
  const { voucherData, error, isReady } = props;

  const {
    userState: { auth0Token },
  } = useUserContext();
  useEffect(() => {
    const fetchReceiverApi = async () => {
      try {
        if (voucherData) {
          const {
            metadata: { receiverId },
          } = voucherData;
          await getReceiverOpen(receiverId, auth0Token);
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error('Error in receiver', e);
      }
    };
    fetchReceiverApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voucherData]);

  if (!isReady) {
    return <Loader />;
  }

  if (error) {
    return (
      <MainContainer>
        <CardContainer>
          <WrpDiv>
            <NdsThemeProvider>
              <ReceiverPageContent>
                <VoucherCode error={error} />
              </ReceiverPageContent>
            </NdsThemeProvider>
          </WrpDiv>
        </CardContainer>
      </MainContainer>
    );
  }

  return (
    <>
      <MainContainer>
        <CardContainer>
          <WrpDiv>
            <NdsThemeProvider>
              <ReceiverPageContent>
                <VoucherInfo voucherData={voucherData} />
                <SeprateHeadLine />
                {voucherData?.code && (
                  <VoucherCode
                    title={voucherData.personalization?.title || DEFAULT_TITLE}
                    code={voucherData.code}
                    hasDepleted={voucherData.balance === 0}
                    hasExpired={voucherData.hasExpired}
                  />
                )}
                <SeprateHeadLine />
                {!voucherData?.hasExpired && voucherData?.balance !== 0 && (
                  <StoreVoucher
                    personalization={voucherData?.personalization}
                    code={voucherData?.code}
                  />
                )}
                <Transactions
                  personalization={voucherData?.personalization}
                  transactions={voucherData.transactions}
                />
                <EcommBanner code={voucherData?.code} />
                <FAQSection>
                  <h2>Top FAQs</h2>
                  <AcrodianSection>
                    <InformationSection personalization={voucherData?.personalization} />
                  </AcrodianSection>
                </FAQSection>
              </ReceiverPageContent>
            </NdsThemeProvider>
          </WrpDiv>
        </CardContainer>
      </MainContainer>
      <ShowFooterSection>
        <PageFooter />
      </ShowFooterSection>
    </>
  );
};

export default Receiver;
